import * as api from "services/api";
import { getErrors } from "helpers/error";

export const UPDATE_GROUP = "[GROUP UPDATE] UPDATE_GROUP";
export const UPDATE_GROUP_ERROR = "[GROUP UPDATE] UPDATE_GROUP_ERROR";
export const UPDATE_GROUP_SUCCESS = "[GROUP UPDATE] UPDATE_GROUP_SUCCESS";

export const SET_VALUE = "[GROUP UPDATE] SET_VALUE";
export const CLEAR_VALUES = "[GROUP UPDATE] CLEAR_VALUES";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function updateGroup(id, model, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: UPDATE_GROUP
		});

		try {
			const { login } = getState();

			let response = await api.sendPut(`/group/${id} `, model, {
				Authorization: "Bearer " + login.token
			});

			if (response.ok) {
				dispatch({
					type: UPDATE_GROUP_SUCCESS
				});

				callback && callback();
			} else {
				let result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: UPDATE_GROUP_ERROR,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);

			return dispatch({
				type: UPDATE_GROUP_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
